/**
 * Canonical taxonomy / API disease names → concise UI labels.
 * API requests must keep using the original names from the ontology.
 */

const API_NAME_TO_UI_LABEL = new Map<string, string>([
  ["diastolic heart failure", "HFpEF"],
  ["systolic heart failure", "HFrEF"],
]);

export function getDiseaseDisplayName(apiName: string): string {
  const key = apiName.trim().toLowerCase();
  return API_NAME_TO_UI_LABEL.get(key) ?? apiName;
}

/** Tooltip: full ontology name + MONDO; includes UI alias when it differs. */
export function getDiseaseTooltipWithMondo(
  apiName: string,
  mondoId: string,
): string {
  const display = getDiseaseDisplayName(apiName);
  if (display === apiName) return `${apiName} (${mondoId})`;
  return `${display} — ${apiName} (${mondoId})`;
}

export function formatDiseaseListForDisplay(commaSeparated: string): string {
  const raw = commaSeparated.trim();
  if (!raw) return commaSeparated;
  return raw
    .split(",")
    .map((s) => getDiseaseDisplayName(s.trim()))
    .join(", ");
}

/** Match search query against canonical name or mapped UI label (substring, case-insensitive). */
export function diseaseNameMatchesSearchQuery(
  nodeName: string,
  qLower: string,
): boolean {
  if (!qLower) return true;
  const nameLower = nodeName.toLowerCase();
  if (nameLower.includes(qLower)) return true;
  const labelLower = getDiseaseDisplayName(nodeName).toLowerCase();
  return labelLower.includes(qLower);
}
